import { getCharacterFallbacks } from './characterThemeAssets.mjs';
import { shareImages, shareImageDimensions } from './shareImageManifest.mjs';
const DEFAULT_FAVICON_PATH = '/favicon-32.png';
export const DEFAULT_FAVICON = `${DEFAULT_FAVICON_PATH}?v=7fa0ba954307`;
export const PUBLIC_PROMOTION_ORIGIN = 'https://newb.rentaltalk.kr';

export function safePublicUrl(value, origin) {
  if (typeof value !== 'string' || !value.trim() || (!/^https?:\/\//i.test(value) && !/^\/(?!\/)/.test(value))) return '';
  try { const url = new URL(value, origin); return ['http:', 'https:'].includes(url.protocol) && !url.username && !url.password ? url.href : ''; }
  catch { return ''; }
}
export function sharingImageSelection(settings, origin) {
  if (['theme', 'custom'].includes(settings?.shareImageMode)) return settings.shareImageMode;
  const value = settings?.defaultImageUrl;
  if (!value) return 'theme';
  const href = safePublicUrl(value, origin);
  if (!href) return 'unresolved';
  const url = new URL(href);
  const local = url.origin === new URL(origin).origin;
  const systemHost = local || ['rental-news-b.netlify.app', 'rental-news-factory.netlify.app'].includes(url.hostname);
  if (systemHost && ['/promotionViewTitle_resize.png', '/promotionViewTitle.png', '/characters/male/title-active.png', '/characters/male/title-active.webp', '/characters/male/share-preview.png'].includes(url.pathname)) return 'theme';
  if (local && url.pathname === '/.netlify/functions/workspace-media' && /^[0-9A-F]{2}$/.test(url.searchParams.get('accountCode') || '') && /^system-settings\/[\w-]+\.(png|jpe?g|gif|webp)$/i.test(url.searchParams.get('asset') || '')) return 'custom';
  return 'unresolved';
}
export function resolveShareImage(settings, origin) {
  const mode = sharingImageSelection(settings, origin);
  // 출처 미확인 레거시 URL은 사용자가 선택하기 전까지 유효한 기존 값을 보존한다.
  const custom = mode !== 'theme' && safePublicUrl(settings?.defaultImageUrl, origin);
  const selected = custom || new URL(getCharacterFallbacks(settings?.characterTheme, 'sharePreview')[0], origin).href;
  const url = new URL(selected);
  if (url.origin === new URL(origin).origin && shareImages[url.pathname]) url.searchParams.set('v', shareImages[url.pathname]);
  return url.href;
}
export function faviconSelection(settings, origin) {
  if (['default', 'custom'].includes(settings?.faviconMode)) return settings.faviconMode;
  if (!settings?.faviconUrl) return 'default';
  const href = safePublicUrl(settings.faviconUrl, origin);
  if (!href) return 'custom';
  const url = new URL(href);
  const systemHost = url.origin === new URL(origin).origin || ['newb.rentaltalk.kr', 'rental-news-b.netlify.app', 'rental-news-factory.netlify.app'].includes(url.hostname);
  return systemHost && [DEFAULT_FAVICON_PATH, '/remake_logo192.png', '/favicon.ico', '/promotionViewTitle_resize.png'].includes(url.pathname) ? 'default' : 'custom';
}
export function resolveFavicon(settings, origin) {
  return (faviconSelection(settings, origin) === 'custom' && safePublicUrl(settings?.faviconUrl, origin)) || new URL(DEFAULT_FAVICON, origin).href;
}
const text = value => typeof value === 'string' ? value.trim() : '';
export function buildSharingMetadata({ origin, identifier = '', settings = null, promotion = null, state = 'active' }) {
  const error = state === 'error';
  const source = error ? null : settings;
  const siteName = text(source?.siteName) || '렌탈프로모션';
  const title = error ? '프로모션을 찾을 수 없습니다' : state === 'inactive' ? text(source?.inactivePromotionTitle) || '프로모션 종료 안내' : text(source?.defaultTitle) || text(promotion?.title) || siteName;
  const description = error ? '공개 중인 프로모션 링크를 확인해주세요.' : state === 'inactive' ? text(source?.inactivePromotionMessage) || '해당 프로모션은 종료되었습니다.' : text(source?.defaultDescription) || '최신 프로모션을 확인하세요';
  const imageSettings = state === 'inactive' ? { characterTheme: source?.characterTheme } : source;
  const image = resolveShareImage(imageSettings, origin);
  const imageUrl = new URL(image);
  // 직접 관리하는 이미지의 실제 크기만 제공하고 업로드·외부 이미지 크기는 추정하지 않는다.
  const dimensions = imageUrl.origin === new URL(origin).origin && shareImageDimensions[imageUrl.pathname];
  const favicon = resolveFavicon(source, origin);
  return { title, description, siteName, image,
    ...(dimensions ? { imageWidth: dimensions.width, imageHeight: dimensions.height } : {}),
    url: new URL(`/${encodeURIComponent(promotion?.slug || identifier)}`, origin).href,
    favicon,
    ...(favicon === new URL(DEFAULT_FAVICON, origin).href ? { siteIcon: new URL('/icons/rnf-app-512.png?v=e06817ffcce5', origin).href } : {}),
    noindex: state !== 'active' };
}
